export default {"src":"/_next/static/media/prisma-erd.98ef54c2.svg","height":650,"width":1929,"blurWidth":0,"blurHeight":0};